<section class="news">
  <div class="component-content">
    <h3 class="news__title">Read about us</h3>
    <app-news-list></app-news-list>
  </div>
</section>
